import { render, staticRenderFns } from "./VehicleStateIconItem.vue?vue&type=template&id=870b060e&scoped=true&"
import script from "./VehicleStateIconItem.vue?vue&type=script&lang=ts&"
export * from "./VehicleStateIconItem.vue?vue&type=script&lang=ts&"
import style0 from "./VehicleStateIconItem.vue?vue&type=style&index=0&id=870b060e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "870b060e",
  null
  
)

export default component.exports